import { render, staticRenderFns } from "./AgGridVue.vue?vue&type=template&id=41955c2d&scoped=true&"
import script from "./AgGridVue.vue?vue&type=script&lang=js&"
export * from "./AgGridVue.vue?vue&type=script&lang=js&"
import style0 from "./AgGridVue.vue?vue&type=style&index=0&id=41955c2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41955c2d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColumnSettingsMenu: require('/app/components/ag-grid/ColumnSettingsMenu.vue').default,VIcon: require('/app/components/ui/v-icon/VIcon.vue').default,VBtn: require('/app/components/ui/v-btn/VBtn.vue').default})
